import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginFormComponent } from './login-form.component';
import {
  DxButtonModule,
  DxCheckBoxModule, DxLoadIndicatorModule, DxLoadPanelModule,
  DxTextBoxModule,
  DxValidationGroupModule,
  DxValidatorModule
} from 'devextreme-angular';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [LoginFormComponent],
  imports: [
    CommonModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxCheckBoxModule,
    DxButtonModule,
    DxValidationGroupModule,
    RouterModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule
  ],
  exports: [LoginFormComponent]
})
export class LoginFormModule { }
